import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';
import { removeFormatBackgroundFromCache } from '~src/sidebar/index';

export const deleteFormatBackground = async (
  backgroundId,
  formatId,
  isGlobal
) => {
  $(`#btn-menu-frames #editor-btn-spinner-${formatId}`).show();
  $(`#delete-tag-${formatId}`).hide();

  const httpClient = await getAxiosClient();
  let table_name = '';
  if (isGlobal === true) {
    table_name = 'editor_backgrounds_default';
  } else {
    table_name = 'editor_backgrounds';
  }
  const url = `${process.env.PARSE_API_URL}/${table_name}/${backgroundId}`;
  const method = 'PUT';
  const data = {
    del_relations: [
      {
        column: 'formats',
        class: 'editor_project_formats_default',
        toIds: [formatId],
      },
    ],
  };
  try {
    await httpClient({ url, method, data: { data }, responseType: 'json' });
    removeFormatBackgroundFromCache(backgroundId, formatId);
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
